// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"8e36f3c7","453":"9c8c2ab4","487":"091e2ec0","777":"aedcae34","977":"48623225"}[chunkId] + ".chunk.js";
};